import React from "react";


interface IncorrectIdProps {
    goBack: () => void
    userId: string
}

const IncorrectId: React.FC<IncorrectIdProps> = ({ goBack, userId }) => {

    return <div>
        <p>Код регистрации введен некорректно или учетная запись уже активирована ({userId}). 
            Обратитесь в Отдел корпоративных льгот – <a href="mailto:social@aeroflot.ru">social@aeroflot.ru</a>
        </p>
        <button onClick={() => goBack()}>Вернуться к регистрации</button>
    </div>;
}

export default IncorrectId;